export type FilterKey = "all" | "pending" | "unpaid" | "paid" | "free";

export type FilterConfig = {
    enabled: boolean;
    color: string;
};

export type SortKey =
    | "pendingFirst"
    | "unpaidFirst"
    | "totalDesc"
    | "totalAsc"
    | "byNumber";

export type TablesState = {
    titleEnabled: boolean;
    filters: Record<FilterKey, FilterConfig>;
    sortOptions: Record<SortKey, boolean>;
};

export const DEFAULT_FILTERS: Record<FilterKey, FilterConfig> = {
    all: { enabled: true, color: "#2196F3" },
    pending: { enabled: true, color: "#FF9800" },
    unpaid: { enabled: true, color: "#F44336" },
    paid: { enabled: true, color: "#4CAF50" },
    free: { enabled: true, color: "#9E9E9E" },
};

export const DEFAULT_SORT_OPTIONS: Record<SortKey, boolean> = {
    pendingFirst: true,
    unpaidFirst: true,
    totalDesc: true,
    totalAsc: true,
    byNumber: true,
};
